//src/components/InboundsExportButton.tsx
import ExportXlsxButton from './ExportXlsxButton';
import { INBOUNDS_XLSX_COLUMNS, mapInboundToRows, getInboundTime } from '../utils/inboundsExport';
import { defaultFilename } from '../utils/filename';

export default function InboundsExportButton({
  source,
  filename,
  className,
}: { source: any[]; filename?: string; className?: string }) {
  const fn = filename ?? defaultFilename('inbounds');

  return (
    <ExportXlsxButton
      source={source}
      filename={fn}
      sheetName="Inbounds"
      columns={INBOUNDS_XLSX_COLUMNS}
      map={mapInboundToRows}
      getTime={getInboundTime}
      className={className}
    />
  );
}
